/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum EnableableFunctionsEnum {
  "pagoPA" = "pagoPA",

  "BPD" = "BPD",

  "FA" = "FA"
}

export type EnableableFunctions = t.TypeOf<typeof EnableableFunctions>;
export const EnableableFunctions = enumType<EnableableFunctionsEnum>(
  EnableableFunctionsEnum,
  "EnableableFunctions"
);
